// extracted by mini-css-extract-plugin
module.exports = {"TripAdvisorLabel":"TripAdvisorLabel_TripAdvisorLabel__LM63j","TextLabel":"TripAdvisorLabel_TextLabel__lljYb","TextLabelTripAdvisor":"TripAdvisorLabel_TextLabelTripAdvisor__Y20U3"};